<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Resúmen Mensual&nbsp
              |
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
        .columns
          .column.is-2
            label.label Periodo:
            .field
              .control
                flat-pickr(
                  v-model='periodo'
                  :config="config"
                  class="input"
                )
          .column.is-3
            .field
              label.label Usuarios
                .control.has-icons-left
                  .select.is-dark.is-rounded
                    select(v-model="usuarioSel")
                      option(v-for="user in usuarios" :key="user.id" :value="user") {{ user.nombre }}
                  .icon.is-small.is-left
                    i.far.fa-user
          .column.is-3
            .field
              label.label Efectivale
                .control.has-icons-left
                  .select.is-dark.is-rounded
                    select(v-model="tarjetaSel")
                      option(v-for="tarj in tarjetas" :key="tarj.id" :value="tarj") {{ tarj.serie }}
                  .icon.is-small.is-left
                    i.far.fa-credit-card
          .column.is-3
            .field
              label.label Vehículo Asignado
                .control.has-icons-left
                  .select.is-dark.is-rounded
                    select(v-model="vehiculoSel")
                      option(v-for="car in vehiculos" :key="car.id" :value="car") {{ car.marca }} - {{ car.modelo }}
                  .icon.is-small.is-left
                    i.far.fa-credit-card
          .column.is-offset-2.is-2(v-show="!verFormCierreMes")
            a.button.is-black.is-rounded(@click="cerrarMes" :disabled="isDisabledFC")
              | Cerrar Mes
          .column.is-offset-2.is-2(v-show="verFormCierreMes")
            FormCierreMes(@saveKmFinal="saveKmFinal")
        .columns(v-show="datosFaltantes.length > 0")
          .column.is-12
            .notification
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}
        .columns(v-show="verNotificacionTarjeta")
          .column.is-offset-4.is-4
            .notificacion.is-light
              strong No hay Tarjetas asignadas para éste usuario.
        .columns(v-show="verNotificacionVehiculo")
          .column.is-offset-4.is-4
            .notificacion.is-light
              strong No hay Vehículos asignados para éste usuario.
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Movimientos en el Mes&nbsp
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  TbMovimientos(:movs="movimientos")
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Totales&nbsp
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  CardTotales(:data="dataTotal")
        .columns
          .column.is-offset-5.is-2
            a.button.is-black.is-rounded.is-block(@click="generarReporte" :disabled="isDisabledFC")
                | Generar Reporte
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBarTransportes.vue'
  import Loader from '@/components/shared/Loader.vue'
  import TbMovimientos from './componentes/TbMovimientos.vue'
  import FormCierreMes from './componentes/FormCierreMes.vue'
  import CardTotales from './componentes/CardTotales.vue'

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import InventarioServices from '@/services/inventario/inventario'
  import usuariosServices from '@/services/usuarios/usuarios'
  import moment from 'moment'
  
  import { mapState } from 'vuex'

  export default {
    name: 'NewResumen',
    components: { NavBar, Loader, TbMovimientos, flatPickr, BulmaAccordion, BulmaAccordionItem, CardTotales, FormCierreMes },
    data() {
      return {
        isLoading: true,
        movimientos: [],
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only          
        },
        periodo: moment().format('YYYY-MM'),
        dataTotal: {},
        verFormCierreMes: false,
        isDisabledFC: true,
        tarjetas: [],
        vehiculos: [],
        usuarios: [],
        verNotificacionTarjeta: false,
        verNotificacionVehiculo: false,
        tarjetaSel: {},
        vehiculoSel: {},
        usuarioSel: {},
        datosFaltantes: [],
        importeMes: 0,
        kms: 0,
        sConsumos: 0,
        promedio: 0,
        calidad: '',
        litrosConsumidos: 0,
        countSalidas: 0
      }
    },
    watch: {
      periodo() {
        this.chekDataFaltante()
      }, 
      tarjetaSel() {
        this.dataTotal = {}
        this.chekDataFaltante()
      },
      vehiculoSel() {
        this.dataTotal = {}
        this.chekDataFaltante()
      },
      usuarioSel () {
        this.dataTotal = {}
        this.obtenerVehiculos()
        this.obtenerTarjetas()
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerUsuarios()
      },
      chekDataFaltante() {
        this.datosFaltantes = []
        if (Object.keys(this.vehiculoSel).length > 0 && Object.keys(this.tarjetaSel).length > 0) {
          this.isDisabledFC = false
          this.obtenerMovimientos()
        } else {
          this.isDisabledFC = true
          if (Object.keys(this.vehiculoSel).length == 0) {
            this.datosFaltantes.push('El vehículo es requerido para la búsqueda.')
          }

          if (Object.keys(this.tarjetaSel).length == 0) {
            this.datosFaltantes.push('La tarjeta es requida para la búsqueda.')
          }
        }
      },
      obtenerMovimientos () {
        this.isLoading = true
        this.countSalidas = 0
        this.importeMes = 0
        this.kms = 0
        this.sConsumos = 0
        this.calidad = ''
        this.promedio = 0
        this.litrosConsumidos = 0
        // InventarioServices.getMovimientos_UPTV(this.usuarioSel.id, this.periodo, this.vehiculoSel.id, this.tarjetaSel.id)
        InventarioServices.getMovimientos_UPTV(this.usuarioSel.id, this.periodo, this.tarjetaSel.id)
          .then((data) => {
            this.movimientos = data.map(this.convetirDataMovs)
            setTimeout(() => {
              this.checkTotales()
            }, 1000)
          })
          .catch((e) => console.log(e))
        this.isLoading = false
      },

      convetirDataMovs(mov) {
        return {
          ...mov,
          asig_extra: Number(mov.asig_extra) ,
          asig_mensual: Number(mov.asig_mensual) ,
          cargaLitros: Number(mov.cargaLitros) ,
          cargaPesos: Number(mov.cargaPesos) ,
          consumo: Number(mov.consumo) ,
          costoLitro: Number(mov.costoLitro) ,
          km_fin: Number(mov.km_fin) ,
          km_inicio: Number(mov.km_inicio) ,
          km_rec: Number(mov.km_rec) ,
          restante: Number(mov.restante) ,
          id: parseInt(mov.id)
        }
      },

      checkTotales () {
        this.dataTotal = {}
        let consumoRef = 0

        switch (parseInt(this.vehiculoSel.tipo)) {
          case 1:
            consumoRef = 10
            break
          case 2:
            consumoRef = 8
            break
          case 3:
            consumoRef = 6
            break
        
          default:
            break
        }
        this.movimientos.forEach(mov => {
          console.log(mov)
          if (mov.cargaPesos > 0) {
            this.kms = this.kms + mov.km_rec
            this.importeMes = this.importeMes + mov.cargaPesos
            this.sConsumos = this.sConsumos + mov.consumo
            this.litrosConsumidos = this.litrosConsumidos + mov.cargaLitros
            this.countSalidas = this.countSalidas + 1
            console.log(this.countSalidas)
          }
        })
        
        setTimeout(() => {
          this.promedio =   (this.kms / this.litrosConsumidos).toFixed(2)
          if (this.promedio > consumoRef ) {
            this.calidad = 'Bueno'
          } else {
            this.calidad = 'Malo'
          }
          let myObt = {
            importeMensual: this.importeMes,
            kmRecorridos: (this.kms).toFixed(2),
            litrosConsumidos: (this.litrosConsumidos).toFixed(2),
            promedio: this.promedio,
            calidad: this.calidad
          }
          this.dataTotal = Object.assign({}, this.dataTotal, myObt)
        }, 1000)
        this.isLoading = false
      },
     
      saveKmFinal (val) {

        if (val !== 'close') {
          let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
          let fechaSalida = moment().format('YYYY-MM-DD')
          InventarioServices.updateCierreMes(fechaReg, fechaSalida, this.periodo, this.vehiculoSel.id, this.tarjetaSel.id, this.userLogin.id, this.userLogin.nombre, val)
            .then((res) => {
              console.log(res)
              if (res.success) {
                let toast = this.$toasted.show(`Se ha registrado el kilómetro del cierre de Mes.`, {
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3500,
                  iconPack: 'fontawesome',
                  icon: 'done',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  }
                })
                this.obtenerMovimientos()
              } else {
                let toast = this.$toasted.show(`${response.respuesta}`, {
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3500,
                  iconPack: 'fontawesome',
                  icon: 'exclamation-triangle',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  }
                })
              }
  
            })
            .catch((e) => console.log(e))
        }
        this.verFormCierreMes = false
      },
      
      generarReporte () {
        if (!this.isDisabledFC) {
          this.isLoading = true
          let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
          InventarioServices.addReporteMensual(fechaReg, this.periodo, this.tarjetaSel.id, this.vehiculoSel.id, this.usuarioSel.id, this.usuarioSel.nombre, this.usuarioSel.ubicacion, this.usuarioSel.departamento, '1588611365500', 'Rafael Rubén Rodríguez Durán', '1571850179002', 'Héctor Torres', this.dataTotal.importeMensual, this.dataTotal.kmRecorridos, this.dataTotal.litrosConsumidos, this.dataTotal.promedio, this.dataTotal.calidad)
            .then((res) => {
              console.log(res)
              if (res.success) {

                let myObj = {
                  fechaReg: fechaReg,
                  periodo: this.periodo,
                  id_tarjeta: this.tarjetaSel.id,
                  id_usuario: this.usuarioSel.id,
                  id_vehiculo: this.vehiculoSel.id,
                  nombre: this.usuarioSel.nombre,
                  idRevisa: '1588611365500',
                  revisa: 'Rafael Rubén Rodríguez Durán',
                  idAutoriza: '1571850179002',
                  autoriza: 'Héctor Torres',
                  impTotal: this.dataTotal.importeMensual,
                  kmTotal: this.dataTotal.kmRecorridos,
                  promedio: this.dataTotal.promedio,
                  calidad: this.dataTotal.calidad,
                  estado: 0
                }
                this.firmarReporte(myObj)
              } else {
                this.isLoading = false
              }
            })
            .catch((e)=> console.log(e))
        }
      },
      firmarReporte(reporte) {
        this.isLoading = false
        this.$store.commit('firmarReporte', reporte)
        this.$router.push('/Transportes/Combustible/Resumen/Firma')

      },
      cerrarMes () {
        if (!this.isDisabledFC) {
          this.verFormCierreMes = true
        }
      },
      obtenerVehiculos() {
        InventarioServices.getVehiculos_user(this.usuarioSel.id)
          .then((data) => {
            console.log(data)
            this.vehiculos = data
            if (this.vehiculos.length == 0) {
              this.verNotificacionVehiculo = true
            } else {
              this.verNotificacionVehiculo = false
            }
          })
          .catch((e) => console.log(e))
        
        this.obtenerTarjetas()
      },
      obtenerTarjetas() {
        InventarioServices.getTarjetas_user(this.usuarioSel.id)
          .then((data) => {
            console.log(data)
            this.tarjetas = data
            if (this.tarjetas.length == 0) {
              this.verNotificacionTarjeta = true
            } else {
              this.verNotificacionTarjeta = false
            }
          })
          .catch((e) => console.log(e))
        this.isLoading = false
      },
      obtenerUsuarios() {

        if (this.userLogin.departamento === 6) {
          usuariosServices.getUsuarios_SeI()
            .then( (res) => {
              this.usuarios = res
              this.isLoading = false
            })
            .catch((e) => {
              this.displayToast(e.message, 'ban', 'OK')
            })
        } else {
          if (this.userLogin.ubicacion === 'EB04') {
            usuariosServices.getUsuarios_Ducto()
              .then( (res) => {
              this.usuarios = res
              this.isLoading = false
              })
              .catch((e) => {
                this.displayToast(e.message, 'ban', 'OK')
              })
          } else {
            usuariosServices.getUsuarios_Ubicacion(this.userLogin.ubicacion)
              .then( (res) => {
                this.usuarios = res
                this.isLoading = false
              })
              .catch((e) => {
                this.displayToast(e.message, 'ban', 'OK')
              })
          }
        }
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backToPage () {
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    }
  }
</script>

<style lang="css" scoped>
  .container {
    max-width: 95vw;
    width: 95vw;
  }
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/NewResumen.vue